import type { PlayedCard, RevealedCard } from '@sincronia/shared';

export type CardTone = 'ok' | 'erro' | 'perdida';

export type BreakdownCard = {
  key: string;
  value: number;
  tone: CardTone;
};

/**
 * Cartas de um jogador no nível, sempre da menor para a maior.
 *
 * Jogadas e descartadas entram na mesma sequência: o que importa para ler o
 * resumo é a posição da carta no baralho, não se ela chegou à pilha. Dentro de
 * um nível os valores são únicos (baralho de 1 a 100 sem repetição), então a
 * ordenação por valor é sempre inequívoca.
 */
export function buildPlayerCards(
  pile: readonly PlayedCard[],
  discarded: readonly RevealedCard[],
  playerId: string,
): BreakdownCard[] {
  const jogadas: BreakdownCard[] = pile
    .filter((card) => card.playerId === playerId)
    .map((card) => ({
      key: card.cardId,
      value: card.value,
      tone: card.causedError ? 'erro' : 'ok',
    }));

  const perdidas: BreakdownCard[] = discarded
    .filter((card) => card.playerId === playerId)
    .map((card) => ({
      key: `perdida-${card.playerId}-${card.value}`,
      value: card.value,
      tone: 'perdida',
    }));

  return [...jogadas, ...perdidas].sort((a, b) => a.value - b.value);
}
